import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import NewsHomePage from "../pages/news/page";
import AdminPage from "../pages/admin/page";
import NewsDetailPage from "../pages/news/detail";
import NewsCategoryPage from "../pages/news/category";
import NewsSearchPage from "../pages/news/search";
import NewsSubscribePage from "../pages/news/subscribe";
import AllNewsPage from "../pages/news/all";
import PopularNewsPage from "../pages/news/popular";
import ReadingListPage from "../pages/news/reading-list";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <NewsHomePage />,
  },
  {
    path: "/haber/:id",
    element: <NewsDetailPage />,
  },
  {
    path: "/kategori/:id",
    element: <NewsCategoryPage />,
  },
  {
    path: "/arama",
    element: <NewsSearchPage />,
  },
  {
    path: "/abonelik",
    element: <NewsSubscribePage />,
  },
  {
    path: "/haberler",
    element: <AllNewsPage />,
  },
  {
    path: "/populer",
    element: <PopularNewsPage />,
  },
  {
    path: "/okuma-listesi",
    element: <ReadingListPage />,
  },
  {
    path: "/admin",
    element: <AdminPage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
